<template>


  <div class="astaxin-cn">
    <div class="header">
      <img class="header-img" src="/static/images/astaxin/membercenter.png" />
    </div>

    <div class="banner"></div>
    <img class="logo" src="/static/images/astaxin/logo.png" />

    <div class="content">
      <div class="code">{{ antiCode }}</div>

      <div v-if="replyCode === '300101' || replyCode === '300102'" class="authentic-text">
        <div>您所查询的是</div>
        <img class="redastaxin" src="/static/images/astaxin/redastaxin.png" />
        <div>正品</div>
      </div>
      
      <div v-if="replyCode === '300106'" class="error-text">您所查询的数码不存在</div>
      <div v-if="replyCode === '300106'" class="error-subtext">谨防假冒请核对后重新输入</div>

      <div v-if="replyCode === '300101' || replyCode === '300102'" class="scan-info">
        <div class="scan-icon">
          <img src="/static/images/astaxin/scanqr.png" />
        </div>
        <div class="scan-details">
          <div>扫码次数：{{ queryCount }}</div>
          <div>首次扫码：{{ firstQueryTime }}</div>
          <div>最近扫码：{{ preQueryTime || firstQueryTime }}</div>
        </div>
      </div>


    </div>
    
    <div v-if="isShow">
      <div class="loading-bg"></div>
      <div class="loading-p">
        <img src="/static/images/loadding.gif"/>
      </div>
    </div>
  </div>
</template>
<style scoped>
.astaxin-cn {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  position: relative;
}

.header {
  width: 100vw;
  height: 6vh;
  background-color: rgb(82, 30, 24);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-img {
  height: 60%;
}

.banner {
  width: 100vw;
  height: 35vh;
  background: url(/static/images/astaxin/hb.png) center center / cover no-repeat;
}

.logo {
  position: absolute;
  width: 60vw;
  top: 8vh;
  margin-left: 30px;
}

.content {
  width: 100vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 5vh;
}

.code {
  font-size: 5.5vw;
  font-weight: 400;
  margin-top: 5vh;
}

.authentic-text {
  font-size: 5vw;
  font-weight: 500;
  margin-top: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redastaxin {
  width: 22vw;
  margin-top: -4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 0;
}

.error-text {
  font-size: 5vw;
  font-weight: 500;
  margin-top: 8vh;
}

.error-subtext {
  font-size: 5vw;
  font-weight: 500;
  margin-top: 2vh;
}

.scan-info {
  font-size: 4vw;
  margin-top: 7vh;
  margin-left: 10vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.scan-icon {
  width: 8vw;
  height: 8vw;
  text-align: right;
  padding-right: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.scan-icon img {
  max-width: 100%;
  max-height: 100%;
}

.scan-details {
  width: 80vw;
  height: 10vh;
}

.loading-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.loading-p {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  text-align: center;
}

.loading-p img {
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
<script>
import { getAntiData } from '../../api/api'

export default {
  data() {
    return {
      eno: '138712948993',
      queryCount: 0,
      firstQueryTime: "",
      preQueryTime: "",
      antiCode: "",
      isShow: false,
      replyCode: ""
    };
  },
  async mounted() {
    this.getResult()
  },
  created() {
    
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      let code = params.c;
      // 如果param.c的长度大于16位，则截取前16位
      if (code && code.length > 16) {
        code = code.substring(0, 16);
      }
      getAntiData(code, this.eno).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.replyCode = "500";
          this.antiCode = code;
          alert("防伪查询失败,请联系管理员");
        }else if(data.code == "300106"){
          this.replyCode = data.data.replyCode;
          this.antiCode = code;
        } else {
          this.replyCode = data.data.replyCode;
          this.antiCode=data.data.code
          this.firstQueryTime=data.data.firstQueryTime
          this.preQueryTime=data.data.preQueryTime
          this.queryCount=data.data.queryCount
        }
        this.isShow = false
      }).catch(err =>
          {
            this.isShow=false
            alert("查询异常，请联系管理员")
          }
      )

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Astaxin/CN.vue